module.exports = __webpack_public_path__ + "img/fc-blackburn-rovers.dcf56033.png";